<template>
  <section v-if="$route.params" class="container-wrapper thank-you-page">
    <h1 class="thank-you-page__title">
      {{ $route.params.title }}
    </h1>
    <div class="thank-you-page__text p" v-html="$route.params.description" />
    <div class="thank-you-page__button-wrapper">
      <BaseButton
        class="thank-you-page__button"
        @click="navigateHome"
      >
        {{ $route.params.buttonLabel }}
      </BaseButton>
    </div>
  </section>
</template>

<script>
  // Step 6
  import { mapActions } from 'vuex'

  export default {
    name: 'ThankYouPage',
    methods: {
      ...mapActions(['fetchThankYouPageData']),
      navigateHome () {
        this.$router.push('/fleet')
      }
    }
  }
</script>

<style lang="scss">
  .thank-you-page {
    @media (-ms-high-contrast: none), (-ms-high-contrast: active) {
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: calc(100vh - 80px);
      min-height: 300px;
    }

    &__title {
      max-width: 100%;
      margin-bottom: 25px;
    }

    &__text {
      max-width: 100%;
      // font-family: "NotoSans", Arial, Helvetica, sans-serif;
      text-align: center;
    }

    &__button {
      &-wrapper {
        display: flex;
        justify-content: center;
        max-width: 100%;
      }

      margin-top: 50px;
      // font-family: "NotoSans", Arial, Helvetica, sans-serif;

      @include mobile {
        margin-top: 25px;
      }
    }
  }
</style>
